import { gql } from '@apollo/client'

export default gql`
  query isBookmarked($nftType: NFTType!, $tokenId: String!) {
    isBookmarked(input: { nftType: $nftType, tokenID: $tokenId })
  }
`
